import { useBrokersServiceBrokersTeamsList } from '@insurance/api/queries'
import { BrokerTeamList } from '@insurance/api/requests'
import { TitleSection } from '@shared/components'
import { usePaginationConfig, useQueryUpdate, useSorting } from '@shared/hooks'
import { Flex } from 'antd'
import { useTranslation } from 'react-i18next'

import { AddTeamButton, TeamsHeader, TeamsTable } from '../components'

type Props = {
  brokerId: string
}

export const TeamsPage = ({ brokerId }: Props) => {
  const { t } = useTranslation()

  const { params, updateQuery } = useQueryUpdate()
  const { triggerSort, getSortedTableColumns } = useSorting<BrokerTeamList>()

  const { data, isLoading } = useBrokersServiceBrokersTeamsList({
    ...params,
    broker: brokerId
  })

  return (
    <>
      <TitleSection
        title={t('teams')}
        count={data?.count}
        isLoading={isLoading}
      >
        <TeamsHeader />
      </TitleSection>

      <Flex vertical gap={16}>
        <Flex justify="end" gap={16} wrap>
          <AddTeamButton broker={Number(brokerId)} />
        </Flex>

        <TeamsTable
          broker={Number(brokerId)}
          data={data?.results}
          loading={isLoading}
          triggerSort={triggerSort}
          getSortedTableColumns={getSortedTableColumns}
          pagination={{
            ...usePaginationConfig(data),
            onChange: (page, pageSize) =>
              updateQuery({
                ...params,
                page: page.toString(),
                pageSize: pageSize.toString()
              })
          }}
        />
      </Flex>
    </>
  )
}
